module.exports = __webpack_public_path__ + "img/yn.b3412f4d.png";